// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2B1wv","title":"Header_title__1aL4F","side":"Header_side__1eZF2"};